import { render, staticRenderFns } from "./BannerDetail.vue?vue&type=template&id=d3704cf4&scoped=true&"
import script from "./BannerDetail.vue?vue&type=script&lang=js&"
export * from "./BannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./BannerDetail.vue?vue&type=style&index=0&id=d3704cf4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3704cf4",
  null
  
)

export default component.exports